import { useEffect } from 'react';

// Disabled: Smart socket and temperature sensor polling
export const useApiInit = () => {
  useEffect(() => {
    // Polling disabled - no device polling active
    console.log('[DEVICE POLLING] Disabled');
  }, []);
};